import _extends from "@babel/runtime/helpers/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["accessibilityLabel", "id", "size", "testID", "UNSAFE_svgProps"];
import React from 'react';
import Surface from '@bubble-ui/primitive-surface';
import Shape from '@bubble-ui/primitive-shape';
import Defs from '@bubble-ui/primitive-defs';
import LinearGradient from '@bubble-ui/primitive-linear-gradient';
import Stop from '@bubble-ui/primitive-stop';
import withProvisionalOverrideFromContext from '@bubble-ui/hoc-with-provisional-override-from-context';
import { usePropsSpreadingDeprecationWarning } from '@bubble-ui/hook-use-props-spreading-deprecation-warning';
var ColoredIllustrationStores = _ref => {
  var {
      accessibilityLabel,
      id,
      size = 100,
      testID,
      UNSAFE_svgProps
      /**
       * @deprecated props spreading is outdated and will be removed with v7.0.0
       */
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  usePropsSpreadingDeprecationWarning({
    componentName: 'ColoredIllustrationStores',
    props,
    useInstead: 'UNSAFE_svgProps',
    removalDate: 'v7.0.0'
  });
  return /*#__PURE__*/React.createElement(Surface, _extends({
    id: id
  }, testID ? {
    testID
  } : {}, UNSAFE_svgProps, {
    accessibilityLabel: accessibilityLabel,
    fill: "none",
    viewBox: "0 0 100 100",
    width: size,
    height: size
  }, props), /*#__PURE__*/React.createElement(Shape, {
    fill: "#9363F9",
    fillRule: "evenodd",
    d: "M59.7 97V76h6.6v21h-6.6ZM35.7 82v-6h6.6v6h-6.6ZM47.7 89V76h6.6v13h-6.6Z"
  }), /*#__PURE__*/React.createElement(Shape, {
    fill: "url(#paint0_linear_5601_1326)",
    d: "M80.745 34.845H20.607v35.782h60.138V34.845Z"
  }), /*#__PURE__*/React.createElement(Shape, {
    fill: "#B37AEA",
    fillRule: "evenodd",
    d: "M80.744 42.29v-7.445H20.607v3.365a10.882 10.882 0 0 0 8.712 4.348c3.33 0 6.307-1.496 8.307-3.856 2 2.352 4.976 3.856 8.306 3.856 3.308 0 6.27-1.481 8.27-3.811a10.87 10.87 0 0 0 8.268 3.81 10.86 10.86 0 0 0 7.93-3.442 10.86 10.86 0 0 0 7.931 3.443c.83 0 1.637-.093 2.413-.268Z"
  }), /*#__PURE__*/React.createElement(Shape, {
    fill: "url(#paint1_linear_5601_1326)",
    fillRule: "evenodd",
    d: "M69.837 28.75H14.894c0 6.02 4.88 10.9 10.9 10.9 3.33 0 6.307-1.497 8.307-3.857 2 2.353 4.976 3.856 8.306 3.856 3.308 0 6.27-1.48 8.27-3.811a10.87 10.87 0 0 0 8.268 3.811 10.86 10.86 0 0 0 7.93-3.443 10.86 10.86 0 0 0 7.931 3.443c6.021 0 10.9-4.879 10.9-10.9H69.837Z"
  }), /*#__PURE__*/React.createElement(Shape, {
    fill: "url(#paint2_linear_5601_1326)",
    fillRule: "evenodd",
    d: "m22.11 15-7.227 13.759 70.823.072L80.068 15H22.11Z"
  }), /*#__PURE__*/React.createElement(Shape, {
    fill: "#9E58FF",
    d: "M70.069 45.94H31.506v24.687h38.563V45.941Z"
  }), /*#__PURE__*/React.createElement(Shape, {
    fill: "url(#paint3_linear_5601_1326)",
    d: "M64.568 50.984h-27.55v19.642h27.55V50.984Z"
  }), /*#__PURE__*/React.createElement(Shape, {
    fill: "#F5DC04",
    fillRule: "evenodd",
    d: "m84.897 17.908-.4-3.547a4.376 4.376 0 0 0-3.857-3.858l-3.547-.4c-.124-.011-.124-.194 0-.205l3.547-.4a4.376 4.376 0 0 0 3.858-3.858l.4-3.547c.011-.123.193-.123.205 0l.4 3.547a4.376 4.376 0 0 0 3.857 3.858l3.547.4c.124.011.124.194 0 .205l-3.547.4a4.376 4.376 0 0 0-3.858 3.858l-.4 3.547c-.011.123-.187.123-.205 0ZM14.655 85.434l-.438-3.888a4.796 4.796 0 0 0-4.228-4.228L6.1 76.88c-.135-.012-.135-.212 0-.225l3.888-.438a4.796 4.796 0 0 0 4.228-4.228l.438-3.887c.013-.135.212-.135.225 0l.438 3.887a4.796 4.796 0 0 0 4.228 4.228l3.887.438c.135.013.135.213 0 .225l-3.887.438a4.796 4.796 0 0 0-4.228 4.228l-.438 3.888c-.013.135-.206.135-.225 0Z"
  }), /*#__PURE__*/React.createElement(Defs, null, /*#__PURE__*/React.createElement(LinearGradient, {
    id: "paint0_linear_5601_1326",
    x1: 27.796,
    x2: 88.392,
    y1: 39.526,
    y2: 74.511,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement(Stop, {
    stopColor: "#FFD1FF"
  }), /*#__PURE__*/React.createElement(Stop, {
    offset: 1,
    stopColor: "#9E58FF"
  })), /*#__PURE__*/React.createElement(LinearGradient, {
    id: "paint1_linear_5601_1326",
    x1: 33.725,
    x2: 68.697,
    y1: 10.306,
    y2: 53.317,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement(Stop, {
    offset: 0.061,
    stopColor: "#FFE2B9"
  }), /*#__PURE__*/React.createElement(Stop, {
    offset: 1,
    stopColor: "#F45FF6"
  })), /*#__PURE__*/React.createElement(LinearGradient, {
    id: "paint2_linear_5601_1326",
    x1: 42.579,
    x2: 54.463,
    y1: 7.548,
    y2: 40.2,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement(Stop, {
    stopColor: "#FFE2B9"
  }), /*#__PURE__*/React.createElement(Stop, {
    offset: 0.997,
    stopColor: "#F45FF6"
  })), /*#__PURE__*/React.createElement(LinearGradient, {
    id: "paint3_linear_5601_1326",
    x1: 59.454,
    x2: 58.999,
    y1: 75.246,
    y2: 48.499,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement(Stop, {
    stopColor: "#6071EC"
  }), /*#__PURE__*/React.createElement(Stop, {
    offset: 0.997,
    stopColor: "#3D404D"
  }))));
};
ColoredIllustrationStores.displayName = 'ColoredIllustrationStores';
export default withProvisionalOverrideFromContext(ColoredIllustrationStores);
//# sourceMappingURL=index.js.map